<template>
  <form>
    <div class="w-full py-4" >
      <form-item label='Note'>
        <div class="relative">
            <TextArea
              v-model="input.note"
              placeholder="Note for Rejection"
              :error="$v.input.note.$dirty && (!$v.input.note.required || !$v.input.note.maxLength)"
              :maxlength="255"
            />
          <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{input.note.length}}/255</div>
        </div>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.note.$dirty && !$v.input.note.required" text="Please fill the Description." />
          <text-error v-if="$v.input.note.$dirty && !$v.input.note.maxLength" text="Max length description channel is 1000 character" />
        </div>
      </form-item>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, decimal, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

export default {
  name: 'RejectionForm',
  mixins: [validationMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    songRejection: {
      type: Object,
      default: () => ({
        id: '',
        note: '',
      }),
    },
    filter: {
      type: Object,
      default: () => ({
        status: 0,
        page: 1,
        per_page: 6,
        sortby: 'submission_date',
        sortorder: 'desc',
        q: '',
        u: '',
      }),
    },
    customSubmit: {
      type: Function,
      default: null,
    },
  },
  computed: {
    getCounterError() {
      return this.input.note.length > 255;
    },
  },
  data() {
    return {
      input: {
        note: '',
      },
    };
  },
  validations() {
    const rule = {
      input: {
        note: {
          required,
          maxLength: maxLength(255),
        },
      },
    };
    return rule;
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$v.$reset();
          this.input.note = '';
        }
      },
    },
  },
  methods: {
    ...mapActions('SongModule', [
      'requestSubmitSubmissionProcess',
    ]),
    async submitRejection() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          if (this.customSubmit) {
            await this.customSubmit({ id: this.songRejection.id, note: this.input.note });
            this.$emit('on-submit-rejection', true);
            return;
          }
          const submissionData = {
            id: this.songRejection.id,
            status: 3,
            note: this.input.note,
          };
          await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
          this.$emit('on-submit-rejection', true);
        }
      } catch (e) {
        console.log('err', e);
      }
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select },
};
</script>

<style scoped>
  .counter-text{
    position: absolute;
    bottom: 15px;
    right: 30px;
  }
  .error-counter span{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/contents/RejectionForm.vue